import React, {useEffect, useState} from 'react';

import {HeaderFilter} from 'src/components/header-filter';
import {FILTER_WIDTH} from 'src/constants';
import {DicItem} from 'src/modules/sso-settings/hooks/use-supported-sso-actions';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import Label from '@pb/kit-component-label';
import {Cell, Head, Row} from '@pb/kit-component-table';


type Props = {
    actionType: string | undefined,
    onActionTypeChange: (actionType: string | undefined) => void,
    actionOptions: DicItem[],
};

export const AuditLogTableHeader: React.FC<Props> = ({
    actionType,
    onActionTypeChange,
    actionOptions,
}) => {
    const [tempActionType, setTempActionType] = useState<string | undefined>(actionType);

    useEffect(() => {
        setTempActionType(actionType);
    }, [actionType]);

    return (
        <Head>
            <Row>
                <Cell width={50}>#</Cell>
                <Cell verticalAlign="top" width={250}>
                    <HeaderFilter
                        caption="Action Type"
                        filterActive={actionType != null ? true : undefined}
                        sortable={false}
                        showFilter={actionOptions.length > 1}
                        onReset={() => {
                            setTempActionType(undefined);
                            onActionTypeChange(undefined);
                        }}
                        onApply={() => onActionTypeChange(tempActionType)}
                        onCancel={() => setTempActionType(actionType)}
                        contentWidth={FILTER_WIDTH}>
                        <div>
                            <Label>Action Type</Label>
                            <ComboBox<string, string>
                                value={tempActionType}
                                onChange={val => setTempActionType(Array.isArray(val) ? val[0] : val)}
                                placeholder="Select action type">
                                {actionOptions
                                    .map(opt => (
                                        <ComboboxItem key={opt.id} caption={opt.title} value={opt.id}/>
                                    ))}
                            </ComboBox>
                        </div>
                    </HeaderFilter>
                </Cell>
                <Cell width={500}>Action Description</Cell>
                <Cell width={250}>Initiator</Cell>
                <Cell width={300}>Timestamp</Cell>
                <Cell>Reason</Cell>
            </Row>
        </Head>
    );
};
